import { Box, Grid, styled } from '@mui/material';

export const SwitchButtonStyle = styled(Box)`
  margin-top: 0.9375rem;
`;

export const FooterContainer = styled(Box)`
  display: flex;
  justify-content: end;
  padding: 20px 0;
`;

export const StyledGridContainer = styled(Grid)({
  width: '100%',
});

export const StyledGridItem = styled(Grid)({
  width: '50%',
});

export const StyledGridItemLastChild = styled(Grid)({
  marginLeft: 'auto',
});

export const CodAlert = styled(Grid)`
  padding-bottom: 20px;
`;
